import React from 'react';
import css from '../../styles/modules/LoadingElements/RadioLoadingBoxes.module.css';

export default function RadioLoadingBoxes() {
  return (
    <div
      className="radio-box-container"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginTop: '1.51041666667vw',
        marginBottom: '3.75vw',
      }}
    >
      {Array(3)
        .fill()
        .map((_, index) => (
          <div key={index} className={css.placeholderBox}></div>
        ))}
    </div>
  );
}
